import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

import "./Navbar.css";

import {faBars} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


function Navbar() {
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const closeTimer = useRef(null);

    const cancelClose = () => {
        if (closeTimer.current) {
            clearTimeout(closeTimer.current);
            closeTimer.current = null;
        }
    };

    const openMenu = () => {
        cancelClose();
        setDropdownOpen(true);
    };

    // Close on a short delay so a slightly wandering cursor on its way from the
    // button to the menu doesn't dismiss it.
    const scheduleClose = () => {
        cancelClose();
        closeTimer.current = setTimeout(() => setDropdownOpen(false), 200);
    };

    useEffect(() => cancelClose, []);

    return (
        <header className="Header">
            <p className="Logo">
                <Link to="/" aria-label="What The FPL home">
                    <img src="/images/WhatTheFPLlogo.png" alt="What The FPL" width="90" height="auto"/>
                </Link>
            </p>

            {/* Kept inline rather than a nested component: a nested one is a new
                component type on every render, so React remounted the menu on each
                state change and the fresh nodes dropped hover mid-move. */}
            <div className={`dropdown ${isDropdownOpen ? "open" : ""}`}
                onMouseEnter={openMenu}
                onMouseLeave={scheduleClose}>
                <button className="dropbtn"
                    aria-label="Menu"
                    aria-haspopup="true"
                    aria-expanded={isDropdownOpen}
                    onFocus={openMenu}
                    onClick={() => setDropdownOpen((open) => !open)}
                >
                    <FontAwesomeIcon icon={faBars} style={{fontSize: 16}}/>
                </button>
                {isDropdownOpen && (
                    <div className="dropdown-content" onClick={() => setDropdownOpen(false)}>
                        <Link to="/">Home</Link>
                        <Link to="/faq">FAQ</Link>
                    </div>
                )}
            </div>
        </header>
    );
}

export default Navbar;
